<template>
  <div class="sections-editor">
    <div v-for="(section, index) in sections" :key="index" class="sections-editor__row">
      <div class="sections-editor__fields">
        <input v-model="section.heading" type="text" placeholder="Heading" @input="emitChange">
        <textarea v-model="section.body" rows="4" placeholder="Body" @input="emitChange"></textarea>
      </div>
      <div class="sections-editor__actions">
        <button type="button" :disabled="index === 0" @click="move(index, -1)">↑</button>
        <button type="button" :disabled="index === sections.length - 1" @click="move(index, 1)">↓</button>
        <button type="button" @click="remove(index)">Remove</button>
      </div>
    </div>
    <button type="button" @click="add">Add section</button>
  </div>
</template>

<script setup>
import { reactive } from 'vue'

const props = defineProps({
  initialSections: { type: Array, default: () => [] },
  onChange: { type: Function, required: true }
})

const sections = reactive(props.initialSections.map(s => ({ heading: s.heading || '', body: s.body || '' })))

function emitChange() {
  props.onChange(sections.map(s => ({ heading: s.heading, body: s.body })))
}

function add() {
  sections.push({ heading: '', body: '' })
  emitChange()
}

function remove(index) {
  sections.splice(index, 1)
  emitChange()
}

function move(index, delta) {
  const target = index + delta
  if (target < 0 || target >= sections.length) return
  const [item] = sections.splice(index, 1)
  sections.splice(target, 0, item)
  emitChange()
}
</script>

<style scoped>
.sections-editor__row { display: flex; gap: 8px; margin-bottom: 12px; }
.sections-editor__fields { flex: 1; display: flex; flex-direction: column; gap: 4px; }
.sections-editor__actions { display: flex; flex-direction: column; gap: 4px; }
</style>
